import {
  KeyboardSensor,
  Modifier,
  PointerSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import { sortableKeyboardCoordinates } from '@dnd-kit/sortable';

// Links and sections only ever move up and down.
export const restrictToVerticalAxis: Modifier = ({ transform }) => ({ ...transform, x: 0 });

// Same activation as Game List: a short press on touch so the page still scrolls.
export const useDragSensors = () =>
  useSensors(
    useSensor(PointerSensor, { activationConstraint: { distance: 8 } }),
    useSensor(TouchSensor, { activationConstraint: { delay: 200, tolerance: 8 } }),
    useSensor(KeyboardSensor, { coordinateGetter: sortableKeyboardCoordinates })
  );
